import React from 'react';
import PropTypes from 'prop-types';

const DienstregelingRow = (props) => {
	const { children } = props;
	return (
		<div className="dienstregeling-form__row">
			<div className="dienstregeling-form__route">{children[0]}</div>
			<div className="dienstregeling-form__date-and-time">
				<div className="dienstregeling-form__date">{children[1]}</div>
				<div className="dienstregeling-form__time">{children[2]}</div>
			</div>
			<div className="dienstregeling-form__submit-btn">{children[3]}</div>
		</div>
	);
};

DienstregelingRow.propTypes = {
	config: PropTypes.object.isRequired,
	children: PropTypes.array.isRequired
};

export default DienstregelingRow;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Group/DienstregelingRow.js